let autocompleteUrl = '', geocodeUrl = ''
const countryFilter = '&in=countryCode:USA,CAN,GUM,PRI,MNP,VIR,NIC,NZL';

function setAuthData(authData: string) {
    autocompleteUrl = `https://autocomplete.search.hereapi.com/v1/autocomplete?apiKey=${authData}`;
    geocodeUrl = `https://lookup.search.hereapi.com/v1/lookup?apiKey=${authData}`;
}

function getSearchUrl(proxy: string) {
    return `${autocompleteUrl}${countryFilter}${proxy}`;
}

function getGeocodeUrl() {
    return geocodeUrl;
}

export default {
    setAuthData: setAuthData,
    getSearchUrl,
    getGeocodeUrl
};